import { render, staticRenderFns } from "./ScrollDown.vue?vue&type=template&id=bf402a0c&scoped=true&"
import script from "./ScrollDown.vue?vue&type=script&lang=js&"
export * from "./ScrollDown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf402a0c",
  null
  
)

export default component.exports